import * as actionTypes from '../types/infoMap';

export function getMap(payload) {
  return {
    type: actionTypes.GET_MAP,
    payload
  };
}
export function getMapSuccess(payload) {
  return {
    type: actionTypes.GET_MAP_SUCCESS,
    payload
  };
}
export function getMapFail(payload) {
  return {
    type: actionTypes.GET_MAP_FAIL,
    payload
  };
}
